export default "__VITE_ASSET__BilypRK0__"